import { render } from "./Kinerja.vue?vue&type=template&id=1b085e8c"
import script from "./Kinerja.vue?vue&type=script&lang=js"
export * from "./Kinerja.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__